import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import authService from '../../api/authService';
import { setUser } from '../../utils/auth';
import HeaderDashboard from './components/header/header';
import SidebarDashboard from './components/sidebar/sidebar';
import FooterDashboard from './components/footer/footer';
import PlusMigrationTakeover from '../../pages/restriction-modals/PlusMigrationTakeover';
import EmailCaptureModal from '../../pages/restriction-modals/EmailCaptureModal';
import './userLayout.scss';

const DashboardLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isProfileLoaded, setIsProfileLoaded] = useState(false);
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean); // split and remove empty parts

  // pathParts = ['search', 'details', '6315']
  const basePath = pathParts.slice(0, 2).join("-"); // 'search-details'

  // Call viewProfile API before dashboard loads
  useLayoutEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await authService.viewProfile();

        if (response?.data?.data) {
          setUser(response.data.data);
          setIsProfileLoaded(true);
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
        // Continue to load dashboard even if profile fetch fails
        setIsProfileLoaded(true);
      }
    };

    fetchUserProfile();
  }, []);

  // Ensure sidebar is collapsed on every page navigation
  useEffect(() => {
    // Ensure sidebar is collapsed on every page load
    // document.body.classList.add('dash-collapsed');

    // Store the collapsed state in localStorage
    try {
      localStorage.setItem('dashCollapsed', 'true');
    } catch (e) {
      // Handle localStorage errors silently
    }
  }, [location.pathname]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Show loading state while profile is being fetched (optional)
  // You can customize this or remove it if you want to render immediately
  if (!isProfileLoaded) {
    return (
      // <div className="front main-content">
      <div className={`front main-content ${basePath}`}>
        <div className='user-container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      </div>
    );
  } 

  return (
    // <div className="front main-content">
    <div className={`front main-content ${basePath}`}>
      <div className='user-container'>
        <SidebarDashboard
          mobileMenuOpen={mobileMenuOpen}
          closeMobileMenu={closeMobileMenu}
        />
        <main className="center-content">
          <HeaderDashboard
            toggleMobileMenu={toggleMobileMenu}
            mobileMenuOpen={mobileMenuOpen}
          />
          <div className='inner-content'>
            <Outlet />
          </div>
        </main>
      </div>
      {/* <FooterDashboard /> */}
      {/* Mobile menu overlay */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}
      {/* One-time deprecation prompt for grandfathered Plus users.
          Renders only when the user is on plan_id 1 or 2 AND
          plus_migration_seen_at is NULL. Self-unmounts after a CTA. */}
      <PlusMigrationTakeover />
      <EmailCaptureModal />
    </div>
  );
};

export default DashboardLayout;
